import { getFileProviderAuthHeaderValue } from 'owa-fileprovider-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export async function getDefaultSPPageContext(webUrl: string) {
    const dummySsid = '00000000-0000-0000-0000-000000000000';
    let token = await getFileProviderAuthHeaderValue(
        AttachmentDataProviderType.OneDrivePro,
        false,
        webUrl
    );
    token = token.substring(7); // Both the existing code and the SharePoint code add 'Bearer' before the token, so we strip it here.

    return {
        authToken: token,
        webAbsoluteUrl: webUrl,
        webTemplate: '21',
        currentUICultureName: 'en-US',
        env: 'edog',
        farmLabel: undefined,
        siteSubscriptionId: dummySsid,
        listUrl: undefined,
        layoutsUrl: '_layouts/15',
        serverRequestPath: '',
        siteAbsoluteUrl: '',
        siteClientTag: '',
        webLogoUrl: '',
        userEmail: '',
        webServerRelativeUrl: '',
        webTitle: '',
        hasManageWebPermissions: true,
        isSiteAdmin: true,
        systemUserKey: '',
        userDisplayName: '',
        userId: 0,
        userLoginName: '',
        pageItemId: 0,
        preferUserTimeZone: true,
        isAppWeb: true,
    };
}
